import { render } from "./LikesModal.vue?vue&type=template&id=79a0f5d2"
import script from "./LikesModal.vue?vue&type=script&lang=js"
export * from "./LikesModal.vue?vue&type=script&lang=js"

import "./LikesModal.vue?vue&type=style&index=0&id=79a0f5d2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__